module.exports = __webpack_public_path__ + "img/1479046075.4bb0bf76.jpg";